import React from 'react'
import Plantilla from '../components/Plantilla'

const plantillas = () => {
  return (
    <Plantilla />
  )
}

export default plantillas